"use client";

import { createContext, useContext } from "react";

import { epaperPublicPath } from "@/utils/epaperPaths";

const EpaperHostContext = createContext(false);

export function EpaperHostProvider({
  enabled,
  children,
}: {
  enabled: boolean;
  children: React.ReactNode;
}) {
  return <EpaperHostContext.Provider value={enabled}>{children}</EpaperHostContext.Provider>;
}

/** Map an internal `/epaper/...` path to the URL the current host should show. */
export function useEpaperPublicPath() {
  const onEpaperHost = useContext(EpaperHostContext);
  return (path: string) => epaperPublicPath(path, onEpaperHost);
}
